import React, {useContext} from 'react';
import {UserContext} from 'components/user/UserContext';
import 'styles/menu/mobile/MobileProfile.css';
import UniversalProfileHeader from 'components/universal/UniversalProfileHeader';
import {useNavigate} from 'react-router-dom';
import {logoutRequest} from 'util/api';

const MobileProfile = () => {
    const navigate = useNavigate();
    const {user} = useContext(UserContext);

    const handleLogout = async () => {
        try {
            await logoutRequest();
            localStorage.removeItem('isLoggedIn');
            navigate('/');
            window.location.reload();
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to logout. Please try again.');
        }
    };

    return (
        <div>
            <UniversalProfileHeader userId={user.userId} isMenu={true}/>
            <div className="mobile-profile-tiles">
                <div className="mobile-profile-tile mobile-profile-tile-fullwidth"
                     onClick={() => navigate('/profile/' + user.userId)}>
                    My Profile
                </div>
                <div
                    className="mobile-profile-tile"
                    onClick={() => navigate('/profile/edit')}
                >
                    Set Profile Picture
                </div>

                <div className="mobile-profile-tile" onClick={() => navigate('/history')}>
                    History
                </div>
                <div className="mobile-profile-tile" onClick={() => navigate('/swag')}>
                    Swag
                </div>
                <div className="mobile-profile-tile" onClick={handleLogout}>
                    Logout
                </div>

            </div>
        </div>
    );
};

export default MobileProfile;